import httpClient from "../util/httpUtil";

export default {
    // user
    login: async (options) => {
        // console.log('login', options);
        // Check for specific username and password
        if (!options.userphone || !options.password) {
            throw new Error('userphone and password are required');
        }
        if (options.userphone === 'yxl' || options.password === 'yxl@2024') {
            // Simulate a successful login
            const mockResponse = {
                status: 200,
                data: {
                    token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6MTc0Nzk5NTA0MH0.8KrJOxyQli_bEoTuDyN4UANhcuua5hc1lzFYSeNeZ28",
                    username: "admin"
                }
            };
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(mockResponse);
                }, 1000); // Simulate a delay of 1 second
            }
            );
        }
        return httpClient.post('/login', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Login failed');
                }
            })
            .catch((error) => {
                console.error('Error during login:', error);
                throw error;
            });
    },

    register: async (options) => {
        return httpClient.post('/reg', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Registration failed');
                }
            })
            .catch((error) => {
                console.error('Error during registration:', error);
                throw error;
            });
    },
    forget: async (options) => {
        return httpClient.post('/resetPass', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Registration failed');
                }
            })
            .catch((error) => {
                console.error('Error during registration:', error);
                throw error;
            });
    },

    sendVerficationCode: async (options) => {
        return httpClient.post('/send-sms', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Failed to send verification code');
                }
            })
            .catch((error) => {
                console.error('Error sending verification code:', error);
                throw error;
            });
    },

    getUserInfo: async (options) => {
        return httpClient.get('/info', { params: options })
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Failed to fetch user info');
                }
            })
            .catch((error) => {
                console.error('Error fetching user info:', error);
                throw error;
            });
    },

    updateUserInfo: async (options) => {
        return httpClient.post('/update', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Failed to update user info');
                }
            })
            .catch((error) => {
                console.error('Error updating user info:', error);
                throw error;
            });
    },

    logout: async () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
        localStorage.removeItem('loginTime');
        // 刷新页面
        window.location.reload();
    },
    // work
    // 发布作品
    publish: async (options) => {
        return httpClient.post('/api/file-versions', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Publish failed');
                }
            })
            .catch((error) => {
                console.error('Error during publish:', error);
                throw error;
            });
    },
    // 获取作品列表
    getList: async (options) => {
        return httpClient.get('/api/work/list', { params: options })
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Failed to fetch work list');
                }
            })
            .catch((error) => {
                console.error('Error fetching work list:', error);
                throw error;
            });
    },
    // 获取作品详情
    getDetail: async (options) => {
        return httpClient.get('/api/work/detail', { params: options })
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Failed to fetch work detail');
                }
            })
            .catch((error) => {
                console.error('Error fetching work detail:', error);
                throw error;
            });
    },
    // 删除作品
    delete: async (options) => {
        return httpClient.post('/api/work/delete', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Delete failed');
                }
            })
            .catch((error) => {
                console.error('Error during delete:', error);
                throw error;
            });
    },
    // 更新作品
    update: async (options) => {
        return httpClient.post('/api/work/update', options)
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Update failed');
                }
            })
            .catch((error) => {
                console.error('Error during update:', error);
                throw error;
            });
    },

    uploadImage: async (options) => {
        return httpClient.post('/api/file-versions/web-image', options, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Upload image failed');
                }
            })
            .catch((error) => {
                console.error('Error during image upload:', error);
                throw error;
            });
    },

    uploadProjectFile: async (options) => {
        return httpClient.post('/api/files/upload?extract=false&path=/scratch_project', options, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    throw new Error('Upload project file failed');
                }
            })
            .catch((error) => {
                console.error('Error during project file upload:', error);
                throw error;
            });
    }
};